import { IUser } from './user'

export interface ProfilePageState {
  profile?: IUser
  isEdit?: boolean
}

export interface ProfilePageContextProps extends ProfilePageState {
  setProfile: (user: IUser) => void
  ownProfile?: boolean
}

export enum ProfilePageActionTypes {
  SET_PROFILE = '[Profile Page] Set Profile',
  SET_EDIT = '[Profile Page] Set Edit',
  SET_OWN_PROFILE = '[Profile Page] Set Own Profile',
}
